module.exports = __webpack_public_path__ + "img/icon-clients-gray.53b49cc3.svg";